// import $ from 'jquery';
import Module from './module';
import Util, { ViewPort } from './lib/util';
import 'modaal/dist/js/modaal.min.js';
import mask from 'jquery-mask-plugin';

const SCHOOL_PATTERN = /\/schools\/([\w-]+)\/*/ig;

/**
 * @class Common
 * @extends {Module}
 */
class Common extends Module {

	constructor(options) {
		super(options);

		window.dynamicModal = [];
		this.$transparencyExpanded = $('.nha-transparency-report-expanded');
	}

	init() {
		// sub-modules must emit an `init` event
		return super.init().then(e => this.emit('init', e));
	}

	main() {
		this.mobilePagination();
		this.modalIframe();
		this.modalInline();
		this.modalAuthor();
		this.setBodyPadding();
	}

	/**
	 * @listens window#load
	 * @listens window#resize
	 * @memberof Common
	 */
	bindEvents() {
		super.bindEvents();

		// phone mask
		$('.nha-form-control.nha-phone-mask').mask('(000) 000-0000');

		// corporate header search desktop
		$('.nha-header-search-btn').on('click', e => {
			e.stopPropagation();
			let target = $(e.currentTarget);

			target.parent('li').addClass('nha-search-expanded');
			$('.nha-header-search-input input').focus();
		});

		$('#header-right-search').on('click', e => {
			e.stopPropagation();
		});

		$(document.body).on('click', e => {
			$('.nha-search-expanded').removeClass('nha-search-expanded');
		});

		$('.nha-live-chat-tab').on('click', e => { $(".lebtn div").trigger("click") });

		$('.nha-nav-primary > li > ul > li a').on('keydown', e => { this.closingNav(e) });


		//aria tags
		this.initAriaExpanded();

		var navObserver = new ResizeObserver(function (mutations) {
			var targetElements = $('.nha-nav-primary > li > ul');
			targetElements.each(function() {
				var height = $(this).height();
				if (height > 0) {
					$(this).prev().attr('aria-expanded', 'true');
				} else {
					$(this).prev().attr('aria-expanded', 'false');
				}
			});
		});
	
	
		//start observing
		$('.nha-nav-primary > li > ul').each(function() {
			navObserver.observe(this);
		});

		// mobile nav
		$('.nha-nav-toggle').on('click', e => { this.mobileNav(e) });
		$('.nha-nav .nha-nav-top-item').on('click', e => { this.mobileNavItem(e) });
		$('.nha-nav .nha-nav-top-item').on('keydown', e => { this.tabbingNav(e) });

		$(document).on('keydown', function(event) {
			var target = $('.nha-nav-toggle');
			if (event.key === "Escape" && target.hasClass('open')) {
				target.toggleClass('open');
				$('.nha-nav').toggleClass('open').css('visibility', 'visible');
			}
		})

		$('.nha-transparency-report-expanded .nha-btn').on('click', e => { this.$transparencyExpanded.fadeOut(); });

		$(document).on('keyup', function(event) {
			if (event.key === "Enter" && $('.nha-education-circle').is(":focus")) {
				$('.nha-transparency-report-expanded').fadeIn();
				$('.nha-transparency-report-expanded').find('a').trigger('focus')
			} 
		})

		$('.nha-education-circle-link').on('click', e => {
			this.$transparencyExpanded.fadeIn();
			this.$transparencyExpanded.find('.nha-btn').focus();
		});

		$('.nha-education-circle').on('click', e => {
			this.$transparencyExpanded.fadeIn();
			this.$transparencyExpanded.find('.nha-btn').focus();
		});

		$(window).on('scroll', e => { this.$transparencyExpanded.fadeOut(); });

		$(window).on('resize', Util.debounce(e => this.onResize(e)));
	}

	/**
	 * Parses the url for the culture code
	 * @memberof Common
	 * @returns {string} The two-letter cultureCode
	 */
	getCultureCode() {
		const path = window.location.pathname + '/'

		if (this.isSchoolSite) {
			let matches = /\/schools\/([\w-]+)\/*/ig.exec(path)

			if (matches != null) {
				const index = matches[0].length
				return Util.trim(path.substring(index, path.indexOf('/', index)), '/');
			}
		} else {
			let matches = /\/(en|es)/gi.exec(path);
			if (matches != null) return Util.trim(matches[0], '/');
		}
	}

	get isSchoolSite() {
		return SCHOOL_PATTERN.test(window.location.pathname);
	}

	/**
	 * Called when the window is resized (after being debounced)
	 * 
	 * @param {ResizeEvent} e 
	 * @memberof Common
	 */
	onResize(e) {
		if (Util.checkWidth() === ViewPort.Desktop) {
			// reset mobile nav
			$('.nha-nav .nha-nav-top-item').removeClass('open');
			$('.nha-nav .nha-nav-primary > li ul').removeAttr('style');
			$('.nha-nav-toggle').removeClass('open');
			$('.nha-nav').removeClass('open').removeAttr('style');
		}

		this.mobilePagination();

		this.setBodyPadding();
	}

	initAriaExpanded() {
		var menuItems = $('.nha-nav-top-item');
		menuItems.each(function() {
                $(this).attr('aria-expanded', 'false');
        });
	}

	mobileNav(e) {
		var target = $(e.currentTarget);

		target.toggleClass('open');
		$('.nha-nav').toggleClass('open').css('visibility', 'visible');
	}

	mobileNavItem(e) {
		var target = $(e.currentTarget);

		if (Util.checkWidth() !== 'desktop') {
			target.toggleClass('open');
			target.closest('li').find('ul').slideToggle();
		}
	}

	setBodyPadding() {
		if (Util.checkWidth() !== ViewPort.Desktop) {
			let headerHeight = $('.nha-header-schools').outerHeight();
			$('body').css('padding-top', headerHeight);
		}
		else {
			$('body').removeAttr('style');
		}
	}

	tabbingNav(e) {
		let target = $(e.currentTarget);
		let children = target.parent().find('ul li a');
		
		if ((e.key === "enter" || e.keyCode === 13) && target.parent().find('ul').length > 0) {
			e.preventDefault();
			this.mobileNavItem(e);
			target.parent().addClass('focused');

			
			for (var child of children) {
				$(child).removeAttr('tabindex');
			}

			if (target.parent().hasClass('focused')) {
				//target.unbind(e);
			}
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.parent().prev();

		if (e.shiftKey && e.keyCode === 9  || e.keyCode === 27) {
			for (var child of $activeElem.parent().prev().find('ul li a')) {
				$(child).attr('tabindex', '-1');
			}

			for (var child of $activeElem.parent().find('ul li a')) {
				$(child).attr('tabindex', '-1');
			}

			$('.nha-nav .nha-nav-primary > li').removeClass('focused');
			
		}

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
		}
	}

	closingNav(e) {
		let target = $(e.currentTarget);
		let menuItem = target.parent().parent().parent();

		if (e.keyCode === 27) {
			e.preventDefault();
			target.blur();

			let children = target.parent().parent().children().find('a');

			if (children !== undefined) {
				for (var child of children) {
					$(child).attr('tabindex', '-1');
				}
			}

			$('.nha-nav .nha-nav-primary > li').removeClass('focused');
			menuItem.attr('tabindex', '-1');
			menuItem.find('a.nha-nav-top-item').focus();
		}

	}

	mobilePagination() {
		if ($('.nha-pagination .js-li-pagination-number ').length > 3) {
			if ($('.js-li-pagination-number.active').prev().hasClass('nha-pagination-previous')) {
				$('.js-li-pagination-number.active').next().addClass('nha-page-show-mobile');
				$('.js-li-pagination-number.active').next().next().addClass('nha-page-show-mobile');
			}
			else if ($('.js-li-pagination-number.active').next().hasClass('nha-pagination-next')) {
				$('.js-li-pagination-number.active').prev().addClass('nha-page-show-mobile');
				$('.js-li-pagination-number.active').prev().prev().addClass('nha-page-show-mobile');
			}
			else {
				$('.js-li-pagination-number.active').prev().addClass('nha-page-show-mobile');
				$('.js-li-pagination-number.active').next().addClass('nha-page-show-mobile');
			}	
		}
	}

	modalInline() {
		$('.modal-inline').modaal({
			type: 'inline',
			width: 725,
			background_scroll: false,
			before_open: function () {
				if (Util.checkWidth() !== ViewPort.Desktop) {
					$('body').css('position', 'fixed');
				}
			},
			after_open: function () {
			},
			after_close: function () {
				$('body').removeAttr('style');
			}
		});
	}

	modalAuthor() {
		$('.modal-author').modaal({
			type: 'inline',
			width: 725,
			custom_class: 'nha-profile-modal',
			background_scroll: false,
			before_open: function () {
				if (Util.checkWidth() !== ViewPort.Desktop) {
					$('body').css('position', 'fixed');
				}
			},
			after_open: function () {
			},
			after_close: function () {
				$('body').removeAttr('style');
			}
		});

		$(window).bind('orientationchange', function (event) {
			if ($('.modaal-wrapper').length) {
				$('.modal-inline').modaal('close');
			}
		});
	}

	modalIframe() {
		var IFrame;

		$('.modal-iframe').modaal({
			type: 'iframe',
			width: 600,
			background_scroll: false,
			before_open: function () {
				if (Util.checkWidth() !== ViewPort.Desktop) {
					$('body').css('position', 'fixed');
					$('.modaal-wrapper').addClass('modal-scrollfix');
				}
			},
			after_open: function () {
				IFrame = iFrameResize({
					heightCalculationMethod: 'lowestElement'
				}, 'iframe.modaal-iframe-elem');

				$('.modaal-wrapper').removeClass('modal-scrollfix');
				$('body').css('overflow', 'hidden').css('position', 'relative');
			},
			after_close: function () {
				IFrame[0].iFrameResizer.close();
				$('body').removeAttr('style');
			}
		});
	}
}

// create an instance to export for other modules to reference
const common = new Common();

export default common;


// WEBPACK FOOTER //
// ./wwwroot/js/app/common.js